import React, { FC } from 'react';
import {
  Puff,
  Rings,
  TailSpin,
  ThreeDots,
  Oval,
  Bars,
  Circles,
  Grid,
  BallTriangle,
  Audio,
  Hearts,
} from 'react-loader-spinner';

const loaderComponents: { [key: string]: React.FC<any> } = {
  Puff,
  Rings,
  TailSpin,
  ThreeDots,
  Oval,
  Bars,
  Circles,
  Grid,
  BallTriangle,
  Audio,
  Hearts,
};

interface CustomLoadingProps {
  type?: string;
  color?: string;
  height?: number;
  width?: number;
}

const CustomLoading: FC<CustomLoadingProps> = ({
  type = 'Puff',
  color = '#00BFFF',
  height = 80,
  width = 80,
}) => {
  const Loader = loaderComponents[type] || Puff;
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader color={color} height={height} width={width} />
    </div>
  );
};

export default CustomLoading;